import { Box, Grid, Link, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useCheckout } from "components/StripeCheckout/useCheckout";
import {
  TERMS_AND_CONDITIONS_LINK_YEARLY,
  VA_MONEY_BACK_GUARANTEE,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import styles from "../styles";

interface Props {
  isVaMoneyBack: boolean;
}

const VaCard = ({ isVaMoneyBack }: Props) => {
  const { plans } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();
  const { getPromoCodeForPlan } = useCheckout();
  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for VA Plan Clicked", {
      source: "Onboarding Paywall",
    });
  };

  const promoCode = getPromoCodeForPlan(Plans.VA_YEARLY);
  const hasPromo = promoCode !== undefined;

  if (!plans) return <></>;
  return (
    <Box sx={[styles.card, { backgroundColor: "#151F16" }]}>
      <Box sx={[styles.chip, { backgroundColor: "purple.main" }]}>
        33x more likely to land a deal
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={6} container alignItems={"flex-end"}>
          <Typography component="div" sx={styles.planName} variant="h4">
            AI Virtual Assistant
          </Typography>
          <Typography>
            {" "}
            <Link
              href={
                isVaMoneyBack
                  ? VA_MONEY_BACK_GUARANTEE
                  : TERMS_AND_CONDITIONS_LINK_YEARLY
              }
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackTermsAndCondition}
              sx={{
                color: "purple.main",
                fontSize: 10,
                textDecoration: "underline",
                textDecorationColor: "purple.main",
              }}
            >
              {isVaMoneyBack ? "Money-Back" : ""} Terms & Conditions
            </Link>
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Grid
            item
            xs={12}
            sx={styles.startAtText}
            justifyContent="flex-start"
            container
          >
            Starts at <br />
          </Grid>
          <Grid item sx={styles.priceText}>
            {hasPromo && (
              <Box component="span">${getPrice(Plans.VA_YEARLY)}</Box>
            )}{" "}
            <Box component="span" sx={hasPromo ? styles.strike : {}}>
              ${plans && plans[Plans.VA_YEARLY]?.price}/mo
            </Box>
          </Grid>
          {promoCode?.dateEnding && (
            <Grid item xs={12} justifyContent="flex-end" container>
              <Typography sx={{ color: "#d95e58", fontSize: 11 }}>
                until {promoCode?.dateEnding}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default VaCard;
